/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateJobPositionLevelCommand
 */
export interface CreateJobPositionLevelCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateJobPositionLevelCommand
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobPositionLevelCommand
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobPositionLevelCommand
     */
    jobPositionId?: string;
}

/**
 * Check if a given object implements the CreateJobPositionLevelCommand interface.
 */
export function instanceOfCreateJobPositionLevelCommand(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateJobPositionLevelCommandFromJSON(json: any): CreateJobPositionLevelCommand {
    return CreateJobPositionLevelCommandFromJSONTyped(json, false);
}

export function CreateJobPositionLevelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateJobPositionLevelCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'jobPositionId': !exists(json, 'jobPositionId') ? undefined : json['jobPositionId'],
    };
}

export function CreateJobPositionLevelCommandToJSON(value?: CreateJobPositionLevelCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'jobPositionId': value.jobPositionId,
    };
}

